import { Reducer } from "redux";
import * as commonActions from "./commonActions";

export interface CommonState {
  /**
   * is application bootstrapped and all pre app logic is done
   */
  isReady: boolean;
}

const initialState: CommonState = {
  isReady: false,
};

type SupportedActions =
  | commonActions.AppInitAction
  | commonActions.AppInitSuccessAction;

export const commonReducer: Reducer<CommonState> = (
  state = initialState,
  action: SupportedActions
) => {
  switch (action.type) {
    case commonActions.APP_INIT_SUCCESS_ACTION: {
      return {
        ...state,
        isReady: true,
      };
    }
    default: {
      return state;
    }
  }
};
